import React from 'react';
import { useRecoilState } from 'recoil';
import { alertState } from '../../../recoil/atoms';
import { AlertContainer, AlertOverlay, AlertContent, AlertButton } from './style';

interface EvAlertProps {
  msg: string;
  onConfirm?: () => void;
}

const EvAlert: React.FC<EvAlertProps> = ({ msg, onConfirm }) => {
  const [isOpen, setIsOpen] = useRecoilState(alertState);

  if (!isOpen) return null;

  const handleClose = () => {
    setIsOpen(false);
    onConfirm?.();
  };

  return (
    <>
      <AlertOverlay onClick={handleClose} />
      <AlertContainer>
        <AlertContent>
          {msg.split('\n').map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              {idx !== msg.split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
        </AlertContent>
        <AlertButton onClick={handleClose}>
          확인
        </AlertButton>
      </AlertContainer>
    </>
  );
};

export default EvAlert;